/**
 * This code was AUTOGENERATED using the codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  getAddressEncoder,
  getProgramDerivedAddress,
  getU8Encoder,
  getUtf8Encoder,
  type Address,
  type ProgramDerivedAddress,
} from '@solana/kit';

export type MemorySeeds = {
  payer: Address;

  memoryId: number;
};

export async function findMemoryPda(
  seeds: MemorySeeds,
  config: { programAddress?: Address | undefined } = {}
): Promise<ProgramDerivedAddress> {
  const {
    programAddress = 'L2TExMFKdjpN9kozasaurPirfHy9P8sbXoAN1qA3S95' as Address<'L2TExMFKdjpN9kozasaurPirfHy9P8sbXoAN1qA3S95'>,
  } = config;
  return await getProgramDerivedAddress({
    programAddress,
    seeds: [
      getUtf8Encoder().encode('memory'),
      getAddressEncoder().encode(seeds.payer),
      getU8Encoder().encode(seeds.memoryId),
    ],
  });
}
